import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, RadioGroup } from '@metarouter-private/mr-mui';
import UPDATE_MODES from 'app/components/analytics-builder/export-import/UPDATE_MODES';
import UpdateModeOption from './UpdateModeOption';

const MODE_OPTIONS = [
  {
    value: UPDATE_MODES.MERGE,
    title: 'Merge',
    description: 'Merge uploaded settings with existing configuration',
  },
  {
    value: UPDATE_MODES.OVERRIDE,
    title: 'Override',
    description: 'Replace all current settings with the uploaded file',
  },
];

export default function UpdateModeSelector({ value, onChange }) {
  return (
    <Stack spacing={1}>
      <Typography variant="body2" fontWeight="medium" component="label">
        Upload Mode
      </Typography>
      <RadioGroup value={value} onChange={onChange}>
        {MODE_OPTIONS.map(option => (
          <UpdateModeOption
            key={option.value}
            value={option.value}
            title={option.title}
            description={option.description}
          />
        ))}
      </RadioGroup>
    </Stack>
  );
}

UpdateModeSelector.propTypes = {
  value: PropTypes.oneOf([UPDATE_MODES.OVERRIDE, UPDATE_MODES.MERGE]).isRequired,
  onChange: PropTypes.func.isRequired,
};
